<template>
	<div id="main">
		<el-tabs v-model="active1">
			<el-tab-pane label="新版介绍" name="first">
				<p>联系方式：+86 021-64309551</p>
			</el-tab-pane>
			<el-tab-pane label="历史版本" name="second">
				<el-timeline>
					<el-timeline-item timestamp="2021/2/1" placement="top">
						<el-card>
							<h4>Stable 3.0版</h4>
							<p>预计2021年2月1日，全面完成3.0版软件开发、测试工作，并逐步替换老客户软件系统。</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2020/11/15" placement="top">
						<el-card>
							<h4>Beta 3.0版</h4>
							<p>采用最新架构，建设3.0版软件系统【3.0版电脑及手机端软件、3.0版手环】。于2020年11月15日完成3.0版大部分软硬件工程，达到使用标准。</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2016/4/3" placement="top">
						<el-card>
							<h4>Stable 2.0版</h4>
							<p>2.0版软件广泛应用于国内二十余家医院系统，主要功能包括但不限于【防逃、禁区管理、区域性自杀预警】，被中科院评为【国内领先、国际先进，具有较高临床运用价值】。</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2014/6/12" placement="top">
						<el-card>
							<h4>Stable 1.0版</h4>
							<p>自2012年公司研究员“李庆华”发表学术论文《区域人员定位系统在精神科病区智能化安全管理的临床应用研究》始，经过2年的技术研发，成功开发出「精神病医院人员定位防逃管控系统」。
							</p>
						</el-card>
					</el-timeline-item>
				</el-timeline>
			</el-tab-pane>
			<el-tab-pane label="上个版本预览" name="third">
				<iframe src="http://192.168.2.99:8080/cysmc-web/index"
					:style="'width: '+iframe_width+'px; height:'+iframe_height+'px; border: 1px solid #030F20;'"></iframe>
			</el-tab-pane>

		</el-tabs>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active1: 'first',
				iframe_width: 0,
				iframe_height: 0
			};
		},
		mounted() {
			this.iframe_width = window.innerWidth - 240;
			this.iframe_height = window.innerHeight - 250;
		}
	};
</script>

<style lang="scss">
</style>
